(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsConfirmClick', ["ConfirmModal", function (ConfirmModal) {
    return {
      restrict: 'A',
      scope: true,
      link: function link(scope, element, attrs) {
        element.on('click', function () {
          var modal = {
            title: attrs.wsConfirmClickTitle || attrs.title || "Confirm",
            subtitle: attrs.wsConfirmClickSubtitle || null,
            body: attrs.wsConfirmClick || "Are you sure?",
            cancelBtn: attrs.wcConfirmClickCancel || "Cancel",
            confirmBtn: attrs.wsConfirmClickConfirm || "OK",
            confirmBtnClasses: attrs.wsConfirmBtnClasses || 'btn-primary',
            confirm: function confirm() {
              scope.$evalAsync(attrs.wsConfirmClickAction || angular.noop);
            }
          };
          ConfirmModal.open(scope, modal);
        });
      }
    };
  }]);
})();
